import Vue from 'vue'
import { API_URL } from '../../api'
import RegionsFilter from '../../filters/RegionsFilter';
const state = {
    regionCreate: {
        createdRegion: null,
        creatingRegion: false,
        createRegionStatus: null
    },
    regionUpdate: {
        updatedRegion: null,
        updatingRegion: false,
        updateRegionStatus: null
    },
    regionDelete: {
        deletingRegion: false,
        deleteRegionStatus: null
    },
    regionSearch: {
        regionsCount: null,
        regions: [],
        searchingRegions: false,
        searchRegionStatus: null
    },
}
const mutations = {
    ['SET_REGION_CREATE'](state, change) {
        state.regionCreate = { ...state.regionCreate, ...change };
    },
    ['SET_REGION_UPDATE'](state, change) {
        state.regionUpdate = { ...state.regionUpdate, ...change };
    },
    ['SET_REGION_DELETE'](state, change) {
        state.regionDelete = { ...state.regionDelete, ...change };
    },
    ['SET_REGION_SEARCH'](state, change) {
        state.regionSearch = { ...state.regionSearch, ...change };
    }
}
const actions = {
    createRegion: ({ commit }, payload) => {
        commit('SET_REGION_CREATE', { createRegionStatus: null, createdRegion: null, creatingRegion: true })
        return Vue.http.post(API_URL + '/regions/create', payload).then(response => {
            commit('SET_REGION_CREATE', { createRegionStatus: 'success', createdRegion: response.body.results.region });
        }).catch(response => {
            commit('SET_REGION_CREATE', { createRegionStatus: 'failed' });
        }).finally(() => {
            commit('SET_REGION_CREATE', { creatingRegion: false });
        });
    },
    updateRegion: ({ commit }, payload) => {
        commit('SET_REGION_UPDATE', { updateRegionStatus: null, updatedRegion: null, updatingRegion: true })
        return Vue.http.post(API_URL + '/regions/update/' + payload.id, payload)
            .then(response => {
                commit('SET_REGION_UPDATE', { updateRegionStatus: 'success', updatedRegion: response.body.results.region });
            })
            .catch(response => {
                commit('SET_REGION_UPDATE', { updateRegionStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_REGION_UPDATE', { updatingRegion: false });
            })
    },
    deleteRegion: ({ commit }, id) => {
        commit('SET_REGION_DELETE', { deleteRegionStatus: null, deletedRegion: null, deletingRegion: true })
        return Vue.http.delete(API_URL + '/regions/delete/' + id).then(response => {
            commit('SET_REGION_DELETE', { deleteRegionStatus: 'success' });
        }).catch(response => {
            commit('SET_REGION_DELETE', { deleteRegionStatus: 'failed' });
        }).finally(() => {
            commit('SET_REGION_DELETE', { deletingRegion: false });
        })
    },
    searchRegions: ({ commit }, payload = { filter: RegionsFilter(), resultMode: 'default' }) => {
        commit('SET_REGION_SEARCH', { searchRegionStatus: null, searchRegion: null, searchingRegions: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/regions' + params).then(response => {
            commit('SET_REGION_SEARCH', { searchRegionStatus: 'success', regions: response.body.results.regions });
        }).catch(response => {
            commit('SET_REGION_SEARCH', { searchRegionStatus: 'failed' });
        }).finally(() => {
            commit('SET_REGION_SEARCH', { searchingRegions: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/regionStore.js